import { makeStyles } from '@material-ui/core';

export const additionalActionsStyles = () => ({
  checkbox: {
    marginLeft: '-7px',
    minWidth: '45%',
    display: 'flex',
    alignItems: 'center'
  }
});

export const FundDoubleListStyles = () => ({
  loading: {
    alignSelf: 'center'
  },
  containerClass: {
    '& > div:nth-of-type(1)': {
      '& > div:last-child': {
        marginBottom: '28px'
      }
    }
  }
});

export const notificationStyle = () => ({
  notificationContainer: {
    width: '100%',
    backgroundColor: '#FFEFDA',
    display: 'flex',
    border: '1px solid #FFA500',
    padding: '3px'
  },
  warningIcon: {
    padding: '3px 6px 0px 3px',
    color: '#FFA500'
  }
});

export const useClassesCustom = makeStyles({
  /* TreeView customization */
  rootTreeView: {
    '& > li': {
      paddingTop: '1px',
      paddingBottom: '1px',
      paddingLeft: '9px'
    }
  },
  popperAutoComplete: {
    // backgroundColor: 'lightgrey'
  },
  /* TreeItem customization */
  rootTreeItem: {
    padding: 0
  },
  contentFF: {
    alignItems: 'flex-start',
    margin: '4px 0px'
  },
  content: {
    alignItems: 'flex-start',
    margin: 0
  },
  label: {
    padding: 0
  },
  iconContainer: {
    margin: 0
  },
  /* Autocomplete customization */
  suggestionsPaperAutoComplete: {
    margin: 0,
    maxHeight: '50vh',
    overflowY: 'auto',
    backgroundColor: '#ffffff',
    border: '1px solid #E0E0E0',
    borderRadius: '2px',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
  },
  listboxAutoComplete: {
    padding: 0
  },
  optionAutoComplete: {
    display: 'block',
    fontFamily: '"Segoe UI", Arial, sans-serif',
    maxWidth: '50vh',
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    fontWeight: 300,
    padding: '6px 8px'
  }
});
